import { FaSpinner } from 'react-icons/fa';
import getColours from '../helpers/getColours';

function ButtonPrimary(props) {
  const {
    children, onClick, disabled, pending, invert, id,
  } = props;
  const { highlightColour } = getColours();

  return (
    <button id={id} disabled={disabled} type="button" style={{ backgroundColor: !invert ? highlightColour : 'white', color: !invert ? 'white' : highlightColour }} className=" disabled:opacity-25 disabled:pointer-events-none  font-semibold text-xs p-2 py-1 rounded outline-none focus:outline-none" onClick={onClick}>
      {children}
      {pending && <FaSpinner className="ml-3 text-white inline animate-spin" /> }
    </button>
  );
}

export default ButtonPrimary;
